import { isEmpty } from 'lodash';
import { getName } from './getName';
import { parseName } from './parseName';
import isFieldEnabled from '../components/CheckoutForm/components/FormField/isFieldEnabled';

export default function getFormFieldValues(fields, pageFields, stripePaymentMethodEvent = null) {
  const fieldArray = Object.keys(fields)
    .filter(key => !isEmpty(fields[key])) // filter out empty fields
    .filter(key => isFieldEnabled(fields[key], fields, pageFields)) // filter out fields that are not enabled
    .map(key => ({
      fieldId: fields[key]._id,
      label: fields[key].label,
      value: fields[key].value,
      meta: fields[key].meta,
      type: fields[key].type,
      required: fields[key].required,
      element: fields[key].element,
      reference: fields[key].reference,
    }))
    .map(field => {
      if (field.element === 'date-time' && field.value) {
        field.value = new Date(field.value).toISOString();
      }

      if (field.element === 'date' && field.value) {
        // For date fields, we add the current time in the user's local timezone
        // This ensures correct timezone handling when converting to UTC/ISO
        // By constructing with components instead of parsing a string,
        // we avoid timezone misinterpretation issues in GMT- timezones
        const [year, month, day] = field.value.split('-').map(Number);
        const now = new Date();

        const localDate = new Date(
          year,
          month - 1,
          day,
          now.getHours(),
          now.getMinutes(),
          now.getSeconds(),
        );

        field.value = localDate.toISOString();
      }

      return field;
    });

  let nameField = fieldArray.find(field => field.type === 'name');
  let firstNameField = fieldArray.find(field => field.type === 'first-name');
  let lastNameField = fieldArray.find(field => field.type === 'last-name');
  let name = getName(fieldArray);
  let emailField = fieldArray.find(field => field.type === 'email');
  let email = emailField?.value;

  const addressLine1Field = fieldArray.find(field => field.type === 'address-line1');
  const addressLine2Field = fieldArray.find(field => field.type === 'address-line2');
  const addressCityField = fieldArray.find(field => field.type === 'address-city');
  const addressStateField = fieldArray.find(field => field.type === 'address-state');
  const addressPostalCodeField = fieldArray.find(field => field.type === 'address-postal_code');
  const addressCountryField = fieldArray.find(field => field.type === 'address-country');

  if (stripePaymentMethodEvent && stripePaymentMethodEvent.billingDetails) {
    const { billingDetails } = stripePaymentMethodEvent;
    const {
      name: billingDetailsName,
      email: billingDetailsEmail,
      address: billingDetailsAddress,
    } = billingDetails;

    if (billingDetailsName && !name) {
      name = billingDetailsName;

      // if the name fields exists and the name is not set, set the name field
      // this happens on express apple/google pay payments
      if (nameField) {
        nameField.value = billingDetailsName;
      }

      try {
        // parse the name into first and last name
        const { firstName, lastName } = parseName(billingDetailsName);

        if (firstNameField) {
          firstNameField.value = firstName;
        }

        if (lastNameField) {
          lastNameField.value = lastName;
        }
      } catch (e) {
        // do nothing
      }
    }

    if (billingDetailsEmail && !email) {
      email = billingDetailsEmail;

      // if the email fields exists and the email is not set, set the email field
      // this happens on express apple/google pay payments
      if (emailField) emailField.value = billingDetailsEmail;
    }

    if (billingDetailsAddress) {
      if (addressLine1Field && !addressLine1Field.value) {
        addressLine1Field.value = billingDetailsAddress.line1 || '';
      }
      if (addressLine2Field && !addressLine2Field.value) {
        addressLine2Field.value = billingDetailsAddress.line2 || '';
      }
      if (addressCityField && !addressCityField.value) {
        addressCityField.value = billingDetailsAddress.city || '';
      }
      if (addressStateField && !addressStateField.value) {
        addressStateField.value = billingDetailsAddress.state || '';
      }
      if (addressPostalCodeField && !addressPostalCodeField.value) {
        addressPostalCodeField.value = billingDetailsAddress.postal_code || '';
      }
      if (addressCountryField && !addressCountryField.value) {
        addressCountryField.value = billingDetailsAddress.country || '';
      }
    }
  }

  return {
    fields: fieldArray,
    name,
    email,
  };
}
